import AvatarImage from 'components/atoms/AvatarImage'
import LinkButton from 'components/atoms/LinkButton'
import I18n from 'core/i18n'
import moment from 'moment'
import * as React from 'react'
import { IUser } from 'static/interfaces'
import styled from 'styled-components'

interface IMessagePreview {
  sender: IUser | Pick<IUser, 'username' | 'avatar_url'>
  body: string
  sent_at: string
  conversation: any
}
interface IProps {
  messages: IMessagePreview[]
}
const Message: React.VFC<IMessagePreview> = ({ sender, body, sent_at, conversation }) => {
  const formattedSentAt = React.useMemo(() => {
    const formattedMoment = moment(sent_at, 'YYYYMMDDHHmmss')
    const isToday = formattedMoment.format('YYYYMMDD') === moment().format('YYYYMMDD')
    return formattedMoment.format(isToday ? 'HH:mm' : 'YYYY/MM/DD')
  }, [sent_at])

  return (
    <MessagePreview>
      <div className="left">
        <AvatarImage avatarURL={sender.avatar_url} size={58} />
        <div className="info">
          <p className="name">{sender.username}</p>
          <p className="text">{body}</p>
        </div>
      </div>
      <div className="right">
        <p className="time">{formattedSentAt}</p>
        <LinkButton miniLink={true} showBorder={true} href={`/conversations/${conversation.slug}`}>
          {I18n.t('generic.reply')}
        </LinkButton>
      </div>
    </MessagePreview>
  )
}
const MessagesPanelBody: React.VFC<IProps> = ({ messages = [] }) => {
  const clampedMessages = messages.filter((_, i) => {
    return i < 2
  })
  return (
    <Messages className="messages">
      {clampedMessages.map((message, i) => (
        <Message key={`message-preview-${i}`} {...message} />
      ))}
    </Messages>
  )
}

const Messages = styled.div``
const MessagePreview = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 58px;
  .left {
    display: flex;
    align-items: center;
    height: 100%;
    margin-right: 20px;
    .info {
      margin-left: 16px;
      .name,
      .text {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }
      .name {
        font-size: 16px;
        font-weight: 700;
      }
      .text {
        font-size: 14px;
      }
    }
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: space-between;
    flex-shrink: 0;
    width: 64px;
    height: 100%;
    .time {
      font-size: 10px;
      margin-bottom: auto;
    }
  }

  & + & {
    margin-top: 30px;
  }
`
export default MessagesPanelBody
